import { selectors, states } from './selectors';
import { CreateControllerParams } from './utils/types';

export function handleEditorMode(
  $w: CreateControllerParams['$w'],
  $bind: CreateControllerParams['$bind'],
  t: CreateControllerParams['flowAPI']['translations']['t'],
) {
  $bind(selectors.title, { text: () => t('tracker.page.title') });
  $bind(selectors.orderNumberLabel, {
    text: () => t('tracker.page.order-number.label'),
  });

  $bind(selectors.methodDetailsTitle, {
    text: () => t('tracker.page.editor.dispatch.title'),
  });

  const orderDetailsItems = [
    {
      title: t('tracker.page.editor.dispatch.address.title'),
      value: t('tracker.page.editor.dispatch.address.details'),
    },
    {
      title: t('tracker.page.editor.dispatch.date-and-time.title'),
      value: t('tracker.page.editor.dispatch.date-and-time.details'),
    },
    {
      title: t('tracker.page.editor.dispatch.order-notes.title'),
      value: t('tracker.page.editor.dispatch.order-notes.details'),
    },
  ];

  $w(selectors.methodDetailsRepeater).forEachItem(($item, _, index) => {
    const item = orderDetailsItems[index];
    $item(selectors.orderDetailsItemTitle).text = item.title;
    $item(selectors.orderDetailsItemValue).text = item.value;
  });

  $w(selectors.stateBox).changeState(states.ready);
}
